class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this.querySelector('[data-cart-notification]');
    this.closeButtons = this.querySelectorAll('[data-cart-notification-close]');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.closeButtons.forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      window.trapFocus(this.notification);
    }, { once: true });

    document.querySelector('[data-cart-notification-overlay]').classList.add('active');
    document.querySelector('site-header').classList.remove('header--transparent-ready');
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.querySelector('[data-cart-notification-overlay]').classList.remove('active');
    document.querySelector('site-header').classList.add('header--transparent-ready');
    document.body.removeEventListener('click', this.onBodyClick);

    window.removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();

    const cartCountIcon = document.querySelector('[data-cart-count-icon]');
    const cartCountValue = document.querySelector('[data-cart-count-value]');

    if (cartCountIcon && cartCountValue) {
      cartCountValue.innerHTML = cartCountValue.innerHTML.replace('(', '').replace(')', '');
    }

    const cartCountBadge = document.querySelector('[data-cart-count-badge]');

    if (cartCountBadge) {
      cartCountBadge.classList.add('active');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[data-cart-notification-product="${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
        selector: '.shopify-section'
      },
      {
        id: 'cart-count',
        section: 'cart-count',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
